module.exports = __webpack_public_path__ + "static/img/10.83b8a8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/zh/10.png
// module id = Fwnc
// module chunks = 0